/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  //   {
  //     url: "/",
  //     name: "الرئيسية",
  //     slug: "home",
  //     icon: `
  //     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // 	<g>
  // 		<path d="M506.555,208.064L263.859,30.367c-4.68-3.426-11.038-3.426-15.716,0L5.445,208.064    c-5.928,4.341-7.216,12.665-2.875,18.593s12.666,7.214,18.593,2.875L256,57.588l234.837,171.943c2.368,1.735,5.12,2.57,7.848,2.57    c4.096,0,8.138-1.885,10.744-5.445C513.771,220.729,512.483,212.405,506.555,208.064z" fill="#000000" data-original="#000000" class=""/>
  // 	</g>
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // 	<g>
  // 		<path d="M442.246,232.543c-7.346,0-13.303,5.956-13.303,13.303v211.749H322.521V342.009c0-36.68-29.842-66.52-66.52-66.52    s-66.52,29.842-66.52,66.52v115.587H83.058V245.847c0-7.347-5.957-13.303-13.303-13.303s-13.303,5.956-13.303,13.303v225.053    c0,7.347,5.957,13.303,13.303,13.303h133.029c6.996,0,12.721-5.405,13.251-12.267c0.032-0.311,0.052-0.651,0.052-1.036v-128.89    c0-22.009,17.905-39.914,39.914-39.914s39.914,17.906,39.914,39.914v128.89c0,0.383,0.02,0.717,0.052,1.024    c0.524,6.867,6.251,12.279,13.251,12.279h133.029c7.347,0,13.303-5.956,13.303-13.303V245.847    C455.549,238.499,449.593,232.543,442.246,232.543z" fill="#000000" data-original="#000000" class=""/>
  // 	</g>
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // <g xmlns="http://www.w3.org/2000/svg">
  // </g>
  // </g></svg>
  // `,
  //   },











  {
    name: "المشاريع",
    slug: "our-projects",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><g xmlns="http://www.w3.org/2000/svg"><path d="m482.284 482h-39.573v-467c0-8.284-6.716-15-15-15h-343.423c-8.284 0-15 6.716-15 15v467h-39.572c-8.284 0-15 6.716-15 15s6.716 15 15 15h452.569c8.284 0 15-6.716 15-15s-6.716-15-15.001-15zm-277.415 0v-102.261h102.261v102.261zm132.261 0v-117.261c0-8.284-6.716-15-15-15h-132.261c-8.284 0-15 6.716-15 15v117.261h-75.581v-452h313.423v452z" fill="#000000" data-original="#000000"/><path d="m223.748 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" fill="#000000" data-original="#000000"/><path d="m361.76 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" fill="#000000" data-original="#000000"/><path d="m223.748 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" fill="#000000" data-original="#000000"/><path d="m361.76 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" fill="#000000" data-original="#000000"/></g></g></svg>`,
    submenu: [
      {
        url: "/projects",
        name: '  الانشاءات',
        slug: 'all-projects',
      },
      {
        url: "/investments",
        name: 'الاستثمارات',
        slug: 'all-projects',
      },
      {
        url: "/jobs",
        name: 'المهن',
        slug: 'all-jobs',
      },
      {
        url: "/workers",
        name: 'الحرفيين',
        slug: 'all-workers',
      },
      {
        url: "/installments-report",
        name: 'تقرير الاقساط',
        slug: 'installments-report',
      },
      {
        url: "/cities",
        name: "المُدن",
        slug: "cities",
      },

      {
        url: "/locations",
        name: "المناطق",
        slug: "locations",
      },




    ]
  },
  // {
  //   url: null,
  //   name: "التقارير",
  //   slug: "Branches",
  //   icon: `
  //   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 460 460" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><path xmlns="http://www.w3.org/2000/svg" d="m7.515625 460h333.941406c4.417969 0 7.542969-4.078125 7.542969-8.5v-172.628906l106.921875-106.929688c3.148437-3.09375 3.195313-8.152344.105469-11.304687l-42.546875-42.601563c-3.199219-3.121094-8.304688-3.125-11.507813-.007812l-52.972656 52.652344v-81.230469c.085938-2.09375-.679688-4.132813-2.117188-5.660157l-80.835937-81.199218c-1.429687-1.570313-3.425781-2.5039065-5.546875-2.589844h-252.984375c-4.414063 0-7.515625 4.078125-7.515625 8.496094v443.007812c0 4.417969 3.101562 8.496094 7.515625 8.496094zm255.398437-173.386719 24.648438 24.648438-37.027344 12.378906zm39.441407 16.8125-31.609375-31.605469 101.515625-101.289062 31.382812 31.382812zm105.519531-168.425781 31.300781 31.300781-24.234375 24.289063-31.351562-31.359375zm-138.875-107.191406 53.144531 53.191406h-53.144531zm-253-11.808594h237v73.449219c-.09375 2.023437.660156 3.992187 2.089844 5.425781 1.425781 1.4375 3.386718 2.207031 5.410156 2.125h72.5v89.644531l-79.453125 79.5c-.839844.820313-1.464844 1.832031-1.820313 2.949219l-11.28125 33.90625h-172.746093c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h167.402343l-4.820312 14.601562c-.960938 2.84375-.210938 5.992188 1.929688 8.097657.5625.5625 1.199218 1.300781 1.875 1.300781h-166.386719c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h213.003906c4.421875 0 8-3.582031 8-8s-3.578125-8-8-8h-38.691406l62.886719-20.847656c1.105468-.363282 2.105468-1 2.902343-1.84375l25.199219-25.402344v149.09375h-317zm0 0" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="m280.703125 383h-213.003906c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h213.003906c4.421875 0 8-3.582031 8-8s-3.578125-8-8-8zm0 0" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="m67.699219 279h113.003906c4.421875 0 8-3.582031 8-8s-3.578125-8-8-8h-113.003906c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0" fill="#000000" data-original="#000000"/></g></svg>
  //   `,
  //   submenu: [
      // {
      //   url: "/sales/report",
      //   name: 'المبيعات',
      //   slug: 'sales-report',
      // },
      // {
      //   url: "/sales/returned-sales",
      //   name: ' مرتجع المبيعات',
      //   slug: 'sales-returned-sales',
      // },
      // {
      //   url: "/sales/deleted",
      //   name: 'المبيعات المحذوفة',
      //   slug: 'sales-deleted',
      // },
      // {
      //   url: "/purchases/report",
      //   name: 'المشتريات',
      //   slug: 'purchases-report',
      // },
      // {
      //   url: "/purchases/returned-purchases",
      //   name: 'مرتجع المشتريات',
      //   slug: 'purchases-returned-purchases',
      // },
    
      // {
      //   url: "/purchases/deleted",
      //   name: 'المشتريات المحذوفة',
      //   slug: 'purchases-deleted',
      // },
      // {
      //   url: "/sales/profites",
      //   name: 'تقرير الأرباح',
      //   slug: 'sales-profites',
      // },
  //   ]
  // },
  {
    name: "الفواتير",
    slug: "sales",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m141.388 43.676c-1.864-2.701-5.266-3.873-8.404-2.898-3.133.977-5.268 3.878-5.268 7.16v42.166c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-18.108l14.84 21.489c2.083 3.013 5.735 4.331 9.081 3.286 3.451-1.077 5.682-4.254 5.682-8.164l-.395-40.821c-.04-4.117-3.39-7.428-7.498-7.428-.024 0-.05 0-.074 0-4.143.04-7.468 3.431-7.428 7.572l.18 18.503z" fill="#000000" data-original="#000000"/><path d="m114.229 90.104v-42.246c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v42.245c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.499z" fill="#000000" data-original="#000000"/><path d="m300.878 40.358c-4.143 0-7.5 3.357-7.5 7.5v42.245c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-42.245c0-4.142-3.357-7.5-7.5-7.5z" fill="#000000" data-original="#000000"/><path d="m405.271 55.552c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-17.638c-4.143 0-7.5 3.357-7.5 7.5v41.858c0 4.143 3.357 7.5 7.5 7.5h17.638c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10.138v-5.929h8.837c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-8.837v-5.93h10.138z" fill="#000000" data-original="#000000"/><path d="m349.073 55.358c2.73 0 5.362.803 7.611 2.322 3.433 2.317 8.095 1.416 10.413-2.017s1.416-8.095-2.017-10.413c-4.738-3.201-10.273-4.893-16.008-4.893-15.783 0-28.623 12.84-28.623 28.623 0 15.782 12.84 28.622 28.623 28.622 6.373 0 12.106-2.107 16.578-6.092.88-.783 1.713-1.643 2.478-2.554 2.66-3.175 2.243-7.905-.932-10.566-3.177-2.66-7.905-2.241-10.566.932-.296.354-.616.685-.955.986-1.708 1.522-3.93 2.294-6.603 2.294-7.512 0-13.623-6.11-13.623-13.622s6.113-13.622 13.624-13.622z" fill="#000000" data-original="#000000"/><path d="m201.627 97.604h.056c3.596-.024 6.789-2.327 7.964-5.782l13.794-41.521c1.307-3.931-.821-8.176-4.753-9.481-3.928-1.306-8.176.821-9.481 4.753l-7.715 23.222-8.121-23.395c-1.358-3.914-5.634-5.988-9.544-4.626-3.913 1.358-5.984 5.631-4.626 9.544l14.461 41.661c1.195 3.371 4.392 5.625 7.965 5.625z" fill="#000000" data-original="#000000"/><path d="m281.213 68.981c0-15.783-12.84-28.623-28.622-28.623s-28.622 12.84-28.622 28.623c0 15.782 12.84 28.622 28.622 28.622s28.622-12.839 28.622-28.622zm-42.244 0c0-7.512 6.11-13.623 13.622-13.623s13.622 6.111 13.622 13.623-6.11 13.622-13.622 13.622-13.622-6.11-13.622-13.622z" fill="#000000" data-original="#000000"/><path d="m307.543 136.201c0 4.143 3.357 7.5 7.5 7.5h90.229c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-90.229c-4.143 0-7.5 3.358-7.5 7.5z" fill="#000000" data-original="#000000"/><path d="m405.271 161.838h-38.533c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h38.533c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z" fill="#000000" data-original="#000000"/><path d="m395.271 453.771c-2.233 0-3.635-1.576-6.986-6.64-3.522-5.32-8.845-13.36-19.494-13.36s-15.972 8.04-19.494 13.36c-3.352 5.063-4.753 6.64-6.986 6.64-2.235 0-3.637-1.577-6.99-6.641-3.521-5.32-8.845-13.359-19.495-13.359s-15.974 8.04-19.496 13.359c-3.353 5.063-4.754 6.641-6.988 6.641-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5c10.65 0 15.974-8.04 19.496-13.359 3.353-5.063 4.754-6.641 6.988-6.641s3.636 1.576 6.988 6.641c3.523 5.319 8.847 13.359 19.497 13.359 10.649 0 15.972-8.04 19.494-13.36 3.352-5.063 4.753-6.64 6.986-6.64s3.635 1.576 6.986 6.64c3.522 5.32 8.845 13.36 19.494 13.36 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z" fill="#000000" data-original="#000000"/><path d="m450.209 380.021c-4.143 0-7.5 3.357-7.5 7.5v92.25c0 9.5-7.729 17.229-17.229 17.229h-338.96c-9.5 0-17.229-7.729-17.229-17.229v-447.542c0-9.5 7.729-17.229 17.229-17.229h52.321c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-52.321c-17.771 0-32.229 14.458-32.229 32.229v447.543c0 17.77 14.458 32.228 32.229 32.228h338.96c17.771 0 32.229-14.458 32.229-32.229v-92.25c0-4.142-3.357-7.5-7.5-7.5z" fill="#000000" data-original="#000000"/><path d="m425.48 0h-256.652c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h256.652c9.5 0 17.229 7.729 17.229 17.229v325.306c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-325.306c0-17.771-14.458-32.229-32.229-32.229z" fill="#000000" data-original="#000000"/><path d="m109.908 221.355v155.778c0 9.714 7.902 17.616 17.616 17.616h73.805c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-73.805c-1.442 0-2.616-1.174-2.616-2.616v-38.836h189.509v41.452h-83.101c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h153.16c9.714 0 17.616-7.902 17.616-17.616v-155.778c0-9.714-7.902-17.616-17.616-17.616h-256.952c-9.713 0-17.616 7.903-17.616 17.616zm17.616-2.616h186.893v41.453h-189.509v-38.837c0-1.442 1.174-2.616 2.616-2.616zm-2.616 104.559v-48.105h189.509v48.105zm262.185 0h-57.676v-48.105h57.676zm-2.616 56.452h-55.06v-41.452h57.676v38.836c0 1.442-1.174 2.616-2.616 2.616zm2.616-158.395v38.837h-57.676v-41.453h55.06c1.442 0 2.616 1.174 2.616 2.616z" fill="#000000" data-original="#000000"/></g></g></svg>`,
    submenu: [
      // {
      //   url: "/sales",
      //   name: 'فاتورة مبيعات',
      //   slug: 'sales-2',
      // },
      {
        url: "/purchases",
        name: 'فاتورة شراء',
        slug: 'purchases',
      },
      // {
      //   url: "/sales/return",
      //   name: 'مرتجع مبيعات',
      //   slug: 'sales-return',
      // },
      // {
      //   url: "/purchases/return",
      //   name: 'مرتجع مشتريات',
      //   slug: 'purchases-return',
      // },
      // {
      //   url: "/customers/payment",
      //   name: 'تحصيل من العملاء',
      //   slug: 'customers-payment',
      // },
      {
        url: "/suppliers/payment",
        name: 'سداد الي الموردين',
        slug: 'suppliers-payment',
      },
    ]
  },
  {
    name: "كشف حساب",
    slug: "customer-report",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><title xmlns="http://www.w3.org/2000/svg">value customers users viewer</title><path xmlns="http://www.w3.org/2000/svg" d="M435.1,298.2l-2.372,1.28c-9.582-11.628-26.183-16.134-38.831-9.724-.045.022-.09.046-.134.069l-5.6,3.015a42.527,42.527,0,0,0-48.7-4.4l-30.155,16.4H269.182a57.961,57.961,0,0,1-25.09-5.749l-5.52-2.67a94.693,94.693,0,0,0-98.552,9.625c-.131.1-.259.2-.381.313l-13.327,11.864a46.226,46.226,0,0,1-17.443,9.723L101.3,303.1a6,6,0,0,0-5.739-4.25H31.108a6,6,0,0,0-5.956,6.726l21.484,176.16a6,6,0,0,0,5.956,5.274h96.674a6,6,0,0,0,5.739-7.75l-12.7-41.674,39.554-25a23.8,23.8,0,0,1,17.365-2.247c.124.031.249.059.375.081l80.459,14.816a104.117,104.117,0,0,0,64.337-9.084,5.918,5.918,0,0,0,.734-.43l139.164-95.552a6,6,0,0,0,1.744-8.041A38.2,38.2,0,0,0,435.1,298.2Zm-35.717,2.228c7.315-3.663,16.524-.66,22.406,4.953l-52.772,28.47-3.1,1.633a45.752,45.752,0,0,0-7.228-13.131Zm-54.113-1.485c.047-.027.1-.053.142-.081a30.516,30.516,0,0,1,31.037.292L349.618,313.6a45.592,45.592,0,0,0-17.138-7.713ZM57.9,475.01,37.885,310.85H91.114l50.05,164.16Zm280.784-69.431a92.038,92.038,0,0,1-56.479,7.848l-80.261-14.78a35.777,35.777,0,0,0-26.085,3.535c-.093.051-.186.107-.277.165l-36.915,23.337-26.3-86.251a58.265,58.265,0,0,0,21.917-12.257l13.139-11.7a82.736,82.736,0,0,1,85.918-8.265l5.519,2.67a70.036,70.036,0,0,0,30.315,6.946h53.525a33.851,33.851,0,0,1,33.2,27.49l-38.795-1.755a232.313,232.313,0,0,0-42.22,1.951,6,6,0,0,0,1.646,11.886,219.979,219.979,0,0,1,40.031-1.848l45.656,2.065c.091,0,.182.006.272.006a6,6,0,0,0,6-6c0-.971-.041-1.933-.1-2.89l6.261-3.3L440.8,308.756a26.214,26.214,0,0,1,31.544,5.056Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M76.974,450.188a18.89,18.89,0,1,0,18.89-18.89A18.911,18.911,0,0,0,76.974,450.188Zm18.89-6.89a6.89,6.89,0,1,1-6.89,6.89A6.9,6.9,0,0,1,95.864,443.3Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M301.622,90.305V70.533a45.544,45.544,0,0,0-91.087,0V90.305a45.544,45.544,0,0,0,91.087,0Zm-79.087,0V70.533a33.544,33.544,0,0,1,67.087,0V90.305a33.544,33.544,0,0,1-67.087,0Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M182.668,259.425H329.49a6,6,0,0,0,6-6V239.653H436a6,6,0,0,0,6-6V194.709a44.973,44.973,0,0,0-42.108-44.856c-3.2-.235-4.845,1.791-6.179,3.418a27.535,27.535,0,0,1-43.442-1.061,6,6,0,0,0-4.975-2.433,44.48,44.48,0,0,0-22.071,6.439,50.437,50.437,0,0,0-35.2-17.459c-3.1-.126-4.668,1.756-6.187,3.6a32.308,32.308,0,0,1-50.977-1.245,5.982,5.982,0,0,0-4.975-2.432,50.215,50.215,0,0,0-34.845,15.2c-.758.775-1.477,1.578-2.178,2.393a44.612,44.612,0,0,0-20.457-6.422c-3.189-.235-4.846,1.791-6.179,3.418a27.534,27.534,0,0,1-43.441-1.061,6.015,6.015,0,0,0-4.975-2.433A44.955,44.955,0,0,0,70,194.709v38.944a6,6,0,0,0,6,6H176.668v13.772A6,6,0,0,0,182.668,259.425Zm160.066-97.458a39.541,39.541,0,0,0,59.2.155A32.987,32.987,0,0,1,430,194.709v32.944H335.49V189.162a50.2,50.2,0,0,0-5.545-22.974A32.433,32.433,0,0,1,342.734,161.967ZM223.3,150.862a44.315,44.315,0,0,0,66.934.159,38.54,38.54,0,0,1,33.26,38.141v58.263H188.668V189.162A38.763,38.763,0,0,1,223.3,150.862ZM82,227.653V194.709a33.179,33.179,0,0,1,29.254-32.738,39.538,39.538,0,0,0,59.191.151,32.735,32.735,0,0,1,11.71,4.132,50.271,50.271,0,0,0-5.487,22.908v38.491Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M412.354,108.179V90.872a40.612,40.612,0,1,0-81.224,0v17.307a40.612,40.612,0,1,0,81.224,0Zm-69.224,0V90.872a28.612,28.612,0,1,1,57.224,0v17.307a28.612,28.612,0,1,1-57.224,0Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M180.87,108.179V90.872a40.612,40.612,0,1,0-81.224,0v17.307a40.612,40.612,0,1,0,81.224,0Zm-69.224,0V90.872a28.612,28.612,0,1,1,57.224,0v17.307a28.612,28.612,0,1,1-57.224,0Z" fill="#000000" data-original="#000000"/></g></svg>`,
    submenu: [
      // {
      //   url: "/customers/new",
      //   name: 'عميل جديد',
      //   slug: 'customers-new',
      // },
      // {
      //   url: "/customers/report",
      //   name: 'حساب العملاء',
      //   slug: 'customers-report',
      // },
      // {
      //   url: "/customers/report-all",
      //   name: 'تقرير العملاء',
      //   slug: 'customers-report-all',
      // },
      {
        url: "/suppliers/new",
        name: 'مورد جديد',
        slug: 'suppliers-new',
      },
      {
        url: "/suppliers/report",
        name: 'حساب الموردين',
        slug: 'suppliers-report',
      },
      {
        url: "/suppliers/report-all",
        name: 'تقرير الموردين',
        slug: 'suppliers-report-all',
      },
    ]
  },
  // {
  //   name: "المنتجات",
  //   slug: "products",
  //   icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 468 468" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m466.197 190.749-43.786-69.076c-1.213-1.913-3.012-3.505-5.07-4.455l-178.101-84.07c-3.306-1.56-7.142-1.529-10.422.083l-178.393 87.712c-1.872.92-3.52 2.365-4.68 4.098l-43.787 65.461c-3.779 5.65-1.901 13.702 4.016 17.087l37.745 21.595v100.768c0 4.451 2.464 8.536 6.401 10.613l178.275 94.066c3.523 1.857 7.885 1.822 11.378-.093l178.275-97.818c5.812-3.189 7.937-10.484 4.748-16.294-3.19-5.81-10.487-7.935-16.298-4.747l-160.496 88.063v-143.665l32.525 40.781c3.602 4.516 10.346 5.795 15.347 2.934l168.148-96.204c5.802-3.32 7.764-11.177 4.175-16.839zm-231.976-133.428 151.624 71.571-151.955 83.26-151.736-80.063zm-174.534 90.052 155.889 82.254-38.461 48.224-148.047-84.702zm8.039 175.343v-79.797l106.397 60.873c4.998 2.86 11.75 1.576 15.347-2.934l32.525-40.781v144.038zm223.154-44.865-38.604-48.404 155.887-85.415 31.035 48.96z" fill="#000000" data-original="#000000"/><g><circle cx="412.272" cy="279.798" r="14.004" fill="#000000" data-original="#000000"/></g></g></g></svg>`,
  //   submenu: [
  //     {
  //       url: "/products/new",
  //       name: 'منتج جديد',
  //       slug: 'products-new',
  //     },
  //     {
  //       url: "/products",
  //       name: 'تقرير المنتجات',
  //       slug: 'products',
  //     },
  //     {
  //       url: "/products/report",
  //       name: 'حركة المنتجات',
  //       slug: 'products-report',
  //     },
  //     {
  //       url: "/products/to-order",
  //       name: 'تقرير النواقص',
  //       slug: 'products-to-order',
  //     },
  //     {
  //       url: "/products/stock",
  //       name: 'رصيد بداية المُدة',
  //       slug: 'products-stock',
  //     },
  //     {
  //       url: "/products/category",
  //       name: 'تصنيفات المنتجات',
  //       slug: 'products-category',
  //     },
  //     {
  //       url: "/products/damaged",
  //       name: 'اضافة توالف',
  //       slug: 'products-damaged',
  //     },
  //     {
  //       url: "/products/damaged-report",
  //       name: 'تقرير التوالف',
  //       slug: 'products-damaged-report',
  //     },

  //   ]
  // },
  {
    name: "المصاريف",
    slug: "expenses",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m58 36v-6c0-3.859-3.14-7-7-7h-6v-6.062c0-1.746-.905-3.325-2.421-4.226-1.549-.918-3.418-.952-4.967-.106l-1.612.803v-3.26c0-2.067-1.144-3.871-2.985-4.706-1.77-.802-3.785-.498-5.258.793l-19.133 16.764h-.624c-3.86 0-7 3.141-7 7v26c0 3.859 3.14 7 7 7h43c3.86 0 7-3.141 7-7v-6c2.757 0 5-2.243 5-5v-4c0-2.757-2.243-5-5-5zm-19.463-21.622c.955-.521 2.085-.502 3.021.054.903.536 1.442 1.472 1.442 2.506v6.062h-21.754zm-9.462-6.638c.888-.778 2.052-.957 3.114-.475.875.397 1.811 1.363 1.811 2.884v4.257l-17.235 8.594h-5.106zm26.925 48.26c0 2.757-2.243 5-5 5h-43c-2.757 0-5-2.243-5-5v-26c0-2.757 2.243-5 5-5h43c2.757 0 5 2.243 5 5v6h-10c-5 0-5 5.269-5 7s0 7 5 7h10zm5-11c0 1.654-1.346 3-3 3h-12c-1.801 0-3-.851-3-5s1.199-5 3-5h12c1.654 0 3 1.346 3 3z" fill="#000000" data-original="#000000" class=""/><path d="m49 39c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" fill="#000000" data-original="#000000" class=""/><path d="m49.11 16.768-.625.375c-.286.172-.467.474-.484.806-.017.333.132.652.398.852l4 3c.177.133.389.2.6.2.193 0 .386-.056.555-.168l.176-.117c3.647-2.432 5.929-6.383 6.234-10.715h1.316c.692 0 1.31-.413 1.574-1.052.253-.612.132-1.306-.308-1.793l-4.566-6.142c-.475-.639-1.204-1.005-1.999-1.005h-.001c-.796.001-1.524.367-1.998 1.007l-4.538 6.11c-.444.491-.568 1.192-.312 1.811.267.646.892 1.063 1.591 1.063h1.388c.163 2.308-.98 4.555-3.001 5.768zm4.889-6.77c-.005-.109-.028-.22-.072-.327l-.019-.046c0-.001-.001-.001-.001-.002-.09-.223-.253-.396-.45-.503s0-.001-.001-.001c-.056-.029-.115-.055-.175-.073-.102-.032-.211-.042-.319-.046h-1.676l4.302-5.793c.127-.172.301-.198.393-.198s.266.026.395.198l4.308 5.793h-1.684c-.552 0-1 .447-1 1 0 3.883-1.851 7.499-4.975 9.77l-2.265-1.7c2.515-1.839 3.791-4.975 3.239-8.072z" fill="#000000" data-original="#000000" class=""/></g></g></svg>`,
    submenu: [
      {
        url: "/expenses/categories",
        name: 'وصف مصروف جديد',
        slug: 'expenses-categories',
      },
      {
        url: "/expenses/new",
        name: 'مصروف جديد',
        slug: 'expenses-new',
      },
      {
        url: "/expenses/report",
        name: 'تقرير المصروفات',
        slug: 'expenses-report',
      },
      {
        url: "/expenses/details",
        name: 'تقرير تفصيلي',
        slug: 'expenses-details',
      },

    ]
  },
  {
    name: "الخزينة",
    slug: "dashboard1",
    icon: `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g>
<g xmlns="http://www.w3.org/2000/svg">
	<path d="M347,302c8.271,0,15,6.639,15,14.8h30c0-19.468-12.541-36.067-30-42.231V242h-30v32.58c-17.459,6.192-30,22.865-30,42.42   c0,24.813,20.187,45,45,45c8.271,0,15,6.729,15,15s-6.729,15-15,15s-15-6.729-15-15h-30c0,19.555,12.541,36.228,30,42.42v32.38h30   v-32.38c17.459-6.192,30-22.865,30-42.42c0-24.813-20.187-45-45-45c-8.271,0-15-6.729-15-15S338.729,302,347,302z" fill="#000000" data-original="#000000"/>
	<path d="M347,182c-5.057,0-10.058,0.242-15,0.689V90c0-26.011-18.548-49.61-52.226-66.449C249.4,8.364,209.35,0,167,0   C124.564,0,84.193,8.347,53.323,23.502C18.938,40.385,0,64,0,90v272c0,26,18.938,49.616,53.323,66.498   C84.193,443.653,124.564,452,167,452c17.009,0,33.647-1.358,49.615-4.004C246.826,486.909,294.035,512,347,512   c90.981,0,165-74.019,165-165S437.981,182,347,182z M66.545,50.432C92.992,37.447,129.606,30,167,30c79.558,0,135,31.621,135,60   s-55.442,60-135,60c-37.394,0-74.008-7.447-100.455-20.432C43.32,118.166,30,103.744,30,90S43.32,61.834,66.545,50.432z    M30,142.265c6.724,5.137,14.512,9.907,23.323,14.233C84.193,171.653,124.564,180,167,180c42.35,0,82.4-8.364,112.774-23.551   c8.359-4.18,15.783-8.776,22.226-13.722v45.51c-29.896,8.485-56.359,25.209-76.778,47.548C206.946,239.908,187.386,242,167,242   c-37.394,0-74.008-7.447-100.455-20.432C43.32,210.166,30,195.744,30,182V142.265z M30,234.265   c6.724,5.137,14.512,9.907,23.323,14.233C84.193,263.653,124.564,272,167,272c11.581,0,22.942-0.621,34.021-1.839   c-9.856,18.65-16.242,39.401-18.293,61.395C177.517,331.842,172.263,332,167,332c-37.394,0-74.008-7.447-100.455-20.432   C43.32,300.166,30,285.744,30,272V234.265z M167,422c-37.394,0-74.008-7.447-100.455-20.432C43.32,390.166,30,375.744,30,362   v-37.736c6.724,5.137,14.512,9.907,23.323,14.233C84.193,353.653,124.564,362,167,362c5.23,0,10.459-0.132,15.654-0.388   c1.84,20.868,7.579,40.63,16.486,58.557C188.68,421.376,177.937,422,167,422z M347,482c-74.439,0-135-60.561-135-135   s60.561-135,135-135s135,60.561,135,135S421.439,482,347,482z" fill="#000000" data-original="#000000"/>
</g>
</g></svg>`,
    submenu: [
      {
        url: "/Safe/report",
        name: 'تقرير الخزينة',
        slug: 'Safe-report',
      },
      // {
      //   url: "/Safe/taslim",
      //   name: 'تسليم الخزينة',
      //   slug: 'Safe-taslim',
      // },
      // {
      //   url: "/taslim/report",
      //   name: 'تقرير التسليمات',
      //   slug: 'taslim-report',
      // },
      {
        url: "/Safe/operation",
        name: 'ايرادات آخري',
        slug: 'Safe-operation',
      },
    ]
  },

  {
    name: 'العملاء',
    slug: 'clients',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 344.445 344.445" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
  <g xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M254.557,221.867l-43.444-9.656v-13.728c16.211-11.7,26.944-30.472,27.661-51.778    c14.383-15.178,22.339-34.911,22.339-55.911V66.667c0-14.072-10.517-25.733-24.106-27.539C225.357,15.25,201.129,0,174.357,0    h-9.35c-18.072,0-35.878,6.111-50.144,17.206c-20.04,15.583-31.529,39.083-31.529,64.466V90.8    c0,20.994,7.956,40.733,22.339,55.911c0.722,21.306,11.45,40.078,27.661,51.778v13.728l-43.444,9.65    c-33.3,7.4-56.556,36.383-56.556,70.5v52.078h116.183h45.411h116.183v-52.078C311.112,258.25,287.857,229.267,254.557,221.867z     M215.984,224.672l-8.478,38.144l-26.2-18.711l25.711-21.428L215.984,224.672z M172.223,237.211l-27.778-23.15v-9.089    c8.467,3.9,17.856,6.139,27.778,6.139s19.311-2.239,27.778-6.139v9.089L172.223,237.211z M105.556,94.445v34.239    c-7.206-11.211-11.111-24.239-11.111-37.889v-9.123c0-21.928,9.928-42.228,27.239-55.694    c12.322-9.589,27.711-14.867,43.322-14.867h9.35c23.478,0,44.622,13.944,53.872,35.522L229.673,50h3.661    c9.189,0,16.667,7.478,16.667,16.667v24.128c0,13.65-3.906,26.678-11.111,37.889v-45.35h-7.75    c-10.683,0-20.594-5.306-26.517-14.194l-1.65-2.472h-11.678l-1.617,2.694c-9.278,15.472-26.256,25.083-44.294,25.083H105.556z     M116.668,144.444v-38.889h28.717c20.756,0,40.356-10.472,51.956-27.544c7.428,9.472,18.439,15.372,30.439,16.306v50.128    c0,30.633-24.922,55.556-55.556,55.556C141.59,200.001,116.668,175.078,116.668,144.444z M137.423,222.683l25.711,21.428    l-26.2,18.711l-8.478-38.144L137.423,222.683z M150.445,333.333h-50.444v-22.222H88.89v22.222H44.445v-40.967    c0-28.861,19.678-53.394,47.85-59.65l25.317-5.628l12.122,54.539l19.206-13.722l6.422,6.422L150.445,333.333z M182.851,333.333    h-21.256l5.267-63.217l-8.761-8.761l14.122-10.083l14.122,10.089l-8.761,8.761L182.851,333.333z M300.001,333.333h-44.444v-22.222    h-11.111v22.222h-50.445l-4.917-59.006l6.422-6.422l19.206,13.722l12.122-54.539l25.317,5.628    c28.172,6.256,47.85,30.789,47.85,59.65V333.333z" fill="#000000" data-original="#000000"/>
    </g>
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  <g xmlns="http://www.w3.org/2000/svg">
  </g>
  </g></svg>`,

  submenu: [

    

 {
    url: "/clients",
    name: 'تقرير العملاء',
    slug: 'clientsط§§ط',
  },
   {
    url: "/installments-report",
    name: 'تقرير الاقساط',
    slug: 'installments-report',
  },
  ]
 
  },


  {
    name: "المستخدمين",
    slug: "dashboard",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g>
    <g xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z" fill="#000000" data-original="#000000"/>
      </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    </g></svg>`,
    submenu: [
      {
        url: "/users/all-users",
        name: 'جميع المستخدمين',
        slug: 'users-all-users',
      },
      {
        url: "/users/logs",
        name: 'السجلات',
        slug: 'users-logs',
      },
      // {
      //   url: "/users/jobs",
      //   name: 'الصلحيات و الوظائف',
      //   slug: 'users-jobs',
      // },


    ]
  },



  {
    name: "الشركاء",
    slug: "Parteners",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g>
    <g xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z" fill="#000000" data-original="#000000"/>
      </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    </g></svg>`,
    submenu: [
      {
        url: "/parteners",
        name: 'الشركاء',
        slug: 'all-parteners',
      },
    ]
  },

  {
    name: "اداره السلف",
    slug: "borrowers",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><title xmlns="http://www.w3.org/2000/svg">value customers users viewer</title><path xmlns="http://www.w3.org/2000/svg" d="M435.1,298.2l-2.372,1.28c-9.582-11.628-26.183-16.134-38.831-9.724-.045.022-.09.046-.134.069l-5.6,3.015a42.527,42.527,0,0,0-48.7-4.4l-30.155,16.4H269.182a57.961,57.961,0,0,1-25.09-5.749l-5.52-2.67a94.693,94.693,0,0,0-98.552,9.625c-.131.1-.259.2-.381.313l-13.327,11.864a46.226,46.226,0,0,1-17.443,9.723L101.3,303.1a6,6,0,0,0-5.739-4.25H31.108a6,6,0,0,0-5.956,6.726l21.484,176.16a6,6,0,0,0,5.956,5.274h96.674a6,6,0,0,0,5.739-7.75l-12.7-41.674,39.554-25a23.8,23.8,0,0,1,17.365-2.247c.124.031.249.059.375.081l80.459,14.816a104.117,104.117,0,0,0,64.337-9.084,5.918,5.918,0,0,0,.734-.43l139.164-95.552a6,6,0,0,0,1.744-8.041A38.2,38.2,0,0,0,435.1,298.2Zm-35.717,2.228c7.315-3.663,16.524-.66,22.406,4.953l-52.772,28.47-3.1,1.633a45.752,45.752,0,0,0-7.228-13.131Zm-54.113-1.485c.047-.027.1-.053.142-.081a30.516,30.516,0,0,1,31.037.292L349.618,313.6a45.592,45.592,0,0,0-17.138-7.713ZM57.9,475.01,37.885,310.85H91.114l50.05,164.16Zm280.784-69.431a92.038,92.038,0,0,1-56.479,7.848l-80.261-14.78a35.777,35.777,0,0,0-26.085,3.535c-.093.051-.186.107-.277.165l-36.915,23.337-26.3-86.251a58.265,58.265,0,0,0,21.917-12.257l13.139-11.7a82.736,82.736,0,0,1,85.918-8.265l5.519,2.67a70.036,70.036,0,0,0,30.315,6.946h53.525a33.851,33.851,0,0,1,33.2,27.49l-38.795-1.755a232.313,232.313,0,0,0-42.22,1.951,6,6,0,0,0,1.646,11.886,219.979,219.979,0,0,1,40.031-1.848l45.656,2.065c.091,0,.182.006.272.006a6,6,0,0,0,6-6c0-.971-.041-1.933-.1-2.89l6.261-3.3L440.8,308.756a26.214,26.214,0,0,1,31.544,5.056Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M76.974,450.188a18.89,18.89,0,1,0,18.89-18.89A18.911,18.911,0,0,0,76.974,450.188Zm18.89-6.89a6.89,6.89,0,1,1-6.89,6.89A6.9,6.9,0,0,1,95.864,443.3Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M301.622,90.305V70.533a45.544,45.544,0,0,0-91.087,0V90.305a45.544,45.544,0,0,0,91.087,0Zm-79.087,0V70.533a33.544,33.544,0,0,1,67.087,0V90.305a33.544,33.544,0,0,1-67.087,0Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M182.668,259.425H329.49a6,6,0,0,0,6-6V239.653H436a6,6,0,0,0,6-6V194.709a44.973,44.973,0,0,0-42.108-44.856c-3.2-.235-4.845,1.791-6.179,3.418a27.535,27.535,0,0,1-43.442-1.061,6,6,0,0,0-4.975-2.433,44.48,44.48,0,0,0-22.071,6.439,50.437,50.437,0,0,0-35.2-17.459c-3.1-.126-4.668,1.756-6.187,3.6a32.308,32.308,0,0,1-50.977-1.245,5.982,5.982,0,0,0-4.975-2.432,50.215,50.215,0,0,0-34.845,15.2c-.758.775-1.477,1.578-2.178,2.393a44.612,44.612,0,0,0-20.457-6.422c-3.189-.235-4.846,1.791-6.179,3.418a27.534,27.534,0,0,1-43.441-1.061,6.015,6.015,0,0,0-4.975-2.433A44.955,44.955,0,0,0,70,194.709v38.944a6,6,0,0,0,6,6H176.668v13.772A6,6,0,0,0,182.668,259.425Zm160.066-97.458a39.541,39.541,0,0,0,59.2.155A32.987,32.987,0,0,1,430,194.709v32.944H335.49V189.162a50.2,50.2,0,0,0-5.545-22.974A32.433,32.433,0,0,1,342.734,161.967ZM223.3,150.862a44.315,44.315,0,0,0,66.934.159,38.54,38.54,0,0,1,33.26,38.141v58.263H188.668V189.162A38.763,38.763,0,0,1,223.3,150.862ZM82,227.653V194.709a33.179,33.179,0,0,1,29.254-32.738,39.538,39.538,0,0,0,59.191.151,32.735,32.735,0,0,1,11.71,4.132,50.271,50.271,0,0,0-5.487,22.908v38.491Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M412.354,108.179V90.872a40.612,40.612,0,1,0-81.224,0v17.307a40.612,40.612,0,1,0,81.224,0Zm-69.224,0V90.872a28.612,28.612,0,1,1,57.224,0v17.307a28.612,28.612,0,1,1-57.224,0Z" fill="#000000" data-original="#000000"/><path xmlns="http://www.w3.org/2000/svg" d="M180.87,108.179V90.872a40.612,40.612,0,1,0-81.224,0v17.307a40.612,40.612,0,1,0,81.224,0Zm-69.224,0V90.872a28.612,28.612,0,1,1,57.224,0v17.307a28.612,28.612,0,1,1-57.224,0Z" fill="#000000" data-original="#000000"/></g></svg>`,
    submenu: [
      {
        url: "/borrowers",
        name: 'السلف',
        slug: 'all-borrowers',
      },
    ]
  },








  {
    name: "تسجيل الخروج",
    slug: "logout",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g>
    <g xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15    c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724    c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262    C276.412,478.129,266.908,468.625,255.15,468.625z" fill="#000000" data-original="#000000"/>
      </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173    H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173    c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575    c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z" fill="#000000" data-original="#000000"/>
      </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    </g></svg>`,
    url: '/logout'
  },


  // {
  //   name: "الباركود",
  //   slug: "barcode",
  //   icon: ``,
  //   url: '/barcode'
  // }


]


// sales

